<script setup lang="ts">
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

</script>

<template>
  <div class="flex flex-col px-2 lg:px-8">
    <div class="mb-4 flex flex-col sm:flex-row sm:items-center sm:justify-between">
      <div class="mb-4 flex max-w-lg flex-col sm:mb-0 sm:mr-4 sm:max-w-none">
        <div class="flex items-center gap-8 text-center">
          <h1 class="pb-1 text-left text-title-md2 font-semibold text-black">
            {{ t('maintenance_user_listing.header.title') }}
          </h1>
        </div>

        <p class="max-w-prose text-left font-medium">
          {{ t('maintenance_user_listing.header.subtitle') }}
        </p>
      </div>
      <div class="ml-auto flex items-center lg:py-0">
          <router-link :to="{ name: 'create-maintenance' }">
            <button class="flex flex-row items-center bg-blue px-4 py-3 text-white hover:bg-blue-2">
              {{ t('maintenance_user_listing.header.buttons.create_maintenance') }}
            </button>
          </router-link>
      </div>
    </div>
  </div>
</template>
